











import Vue from "vue";
import Component from "vue-class-component";

@Component({
  props: {
    isSelected: Boolean,
    isDisabled: Boolean,
    onClick: Function
  }
})
export default class Checkbox extends Vue {
  private isDisabled!: Boolean;
  private onClick!: () => {};
  private action() {
    if (!this.isDisabled) {
      this.onClick();
    }
  }
}
